import React from 'react'

export default function Error() {
    document.title = "404 | Error";
  return (
    <div>
      <h2 className='text-danger mt-5 p-5 fw-bold text-center bg-light '>Error this page not found</h2>
    </div>
  )
}
